class SelectComponentService {
  getSelectedValue (options, currentValue) {
    // Optional fields will have an option to select "None" with a value of undefined
    if ((currentValue === undefined) || (currentValue === null)) {
      currentValue = undefined
    }
    let selectedOption = options.find(({ value }) => value === currentValue)
    if (!selectedOption) {
      // null value tells the select component to show no value
      selectedOption = (currentValue === undefined) ? null : { value: currentValue, label: currentValue }
    }
    return selectedOption
  }

  isKnownField (options, currentValue) {
    // Valid values are empty or a value in the list of options
    return (currentValue === undefined) || (currentValue === null) || !!options.find(({ value }) => value === currentValue)
  }
}

export const selectComponentService = new SelectComponentService()
